import { Phone } from 'lucide-static';
import { html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-phone')
export class PdsIconPhone extends PdsIcon {
  @state()
  icon = Phone;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
